import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface ConfirmDialogProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    title?: string;
    description?: ReactNode;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    confirmVariant?: "destructive" | "default";
}

export default function ConfirmDialog({
                                          isOpen,
                                          onOpenChange,
                                          title = "Are you sure?",
                                          description,
                                          confirmText = "Confirm",
                                          cancelText = "Cancel",
                                          onConfirm,
                                          confirmVariant = "destructive",
                                      }: ConfirmDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[400px]">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                {description && <p className="my-2 text-sm text-muted-foreground">{description}</p>}
                <DialogFooter className="flex justify-end gap-2">
                    <Button variant="outline" onClick={() => onOpenChange(false)}>{cancelText}</Button>
                    <Button
                        variant={confirmVariant}
                        onClick={() => {
                            onConfirm();
                            onOpenChange(false);
                        }}
                    >
                        {confirmText}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
